"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SiteSettingsFieldset;
(function (SiteSettingsFieldset) {
    SiteSettingsFieldset[SiteSettingsFieldset["EVENTS_SUMMARY"] = 0] = "EVENTS_SUMMARY";
})(SiteSettingsFieldset = exports.SiteSettingsFieldset || (exports.SiteSettingsFieldset = {}));
var ComponentFieldset;
(function (ComponentFieldset) {
    ComponentFieldset[ComponentFieldset["SITE_SETTINGS"] = 0] = "SITE_SETTINGS";
    ComponentFieldset[ComponentFieldset["DRAFT"] = 1] = "DRAFT";
})(ComponentFieldset = exports.ComponentFieldset || (exports.ComponentFieldset = {}));
var StatusFilter;
(function (StatusFilter) {
    StatusFilter[StatusFilter["FUTURE_AND_PAST"] = 0] = "FUTURE_AND_PAST";
    StatusFilter[StatusFilter["FUTURE_ONLY"] = 1] = "FUTURE_ONLY";
})(StatusFilter = exports.StatusFilter || (exports.StatusFilter = {}));
var RsvpStatusOptions;
(function (RsvpStatusOptions) {
    RsvpStatusOptions[RsvpStatusOptions["YES_ONLY"] = 0] = "YES_ONLY";
    RsvpStatusOptions[RsvpStatusOptions["YES_AND_NO"] = 1] = "YES_AND_NO";
})(RsvpStatusOptions = exports.RsvpStatusOptions || (exports.RsvpStatusOptions = {}));
var EventStatus;
(function (EventStatus) {
    EventStatus[EventStatus["SCHEDULED"] = 0] = "SCHEDULED";
    EventStatus[EventStatus["STARTED"] = 1] = "STARTED";
    EventStatus[EventStatus["ENDED"] = 2] = "ENDED";
    EventStatus[EventStatus["CANCELED"] = 3] = "CANCELED";
})(EventStatus = exports.EventStatus || (exports.EventStatus = {}));
var EventType;
(function (EventType) {
    EventType[EventType["NA_EVENT_TYPE"] = 0] = "NA_EVENT_TYPE";
    EventType[EventType["RSVP"] = 1] = "RSVP";
    EventType[EventType["TICKETS"] = 2] = "TICKETS";
    EventType[EventType["EXTERNAL"] = 3] = "EXTERNAL";
})(EventType = exports.EventType || (exports.EventType = {}));
var RegistrationStatus;
(function (RegistrationStatus) {
    RegistrationStatus[RegistrationStatus["NA_REGISTRATION_STATUS"] = 0] = "NA_REGISTRATION_STATUS";
    RegistrationStatus[RegistrationStatus["CLOSED"] = 1] = "CLOSED";
    RegistrationStatus[RegistrationStatus["CLOSED_MANUALLY"] = 2] = "CLOSED_MANUALLY";
    RegistrationStatus[RegistrationStatus["OPEN_RSVP"] = 3] = "OPEN_RSVP";
    RegistrationStatus[RegistrationStatus["OPEN_RSVP_WAITLIST"] = 4] = "OPEN_RSVP_WAITLIST";
    RegistrationStatus[RegistrationStatus["OPEN_TICKETS"] = 5] = "OPEN_TICKETS";
    RegistrationStatus[RegistrationStatus["OPEN_EXTERNAL"] = 6] = "OPEN_EXTERNAL";
})(RegistrationStatus = exports.RegistrationStatus || (exports.RegistrationStatus = {}));
var EventFieldset;
(function (EventFieldset) {
    EventFieldset[EventFieldset["FULL"] = 0] = "FULL";
    EventFieldset[EventFieldset["DETAILS"] = 1] = "DETAILS";
    EventFieldset[EventFieldset["TEXTS"] = 2] = "TEXTS";
    EventFieldset[EventFieldset["REGISTRATION"] = 3] = "REGISTRATION";
    EventFieldset[EventFieldset["URLS"] = 4] = "URLS";
    EventFieldset[EventFieldset["FORM"] = 5] = "FORM";
    EventFieldset[EventFieldset["DASHBOARD"] = 6] = "DASHBOARD";
    EventFieldset[EventFieldset["FEED"] = 7] = "FEED";
})(EventFieldset = exports.EventFieldset || (exports.EventFieldset = {}));
var InputControlType;
(function (InputControlType) {
    InputControlType[InputControlType["INPUT"] = 0] = "INPUT";
    InputControlType[InputControlType["TEXTAREA"] = 1] = "TEXTAREA";
    InputControlType[InputControlType["DROPDOWN"] = 2] = "DROPDOWN";
    InputControlType[InputControlType["RADIO"] = 3] = "RADIO";
    InputControlType[InputControlType["CHECKBOX"] = 4] = "CHECKBOX";
    InputControlType[InputControlType["NAME"] = 5] = "NAME";
    InputControlType[InputControlType["GUEST_CONTROL"] = 6] = "GUEST_CONTROL";
    InputControlType[InputControlType["ADDRESS_SHORT"] = 7] = "ADDRESS_SHORT";
    InputControlType[InputControlType["ADDRESS_FULL"] = 8] = "ADDRESS_FULL";
    InputControlType[InputControlType["DATE"] = 9] = "DATE";
})(InputControlType = exports.InputControlType || (exports.InputControlType = {}));
var Relation;
(function (Relation) {
    Relation[Relation["ATTENDING"] = 0] = "ATTENDING";
})(Relation = exports.Relation || (exports.Relation = {}));
var EmailNotificationTiming;
(function (EmailNotificationTiming) {
    EmailNotificationTiming[EmailNotificationTiming["INSTANT"] = 0] = "INSTANT";
    EmailNotificationTiming[EmailNotificationTiming["BEFORE_1_DAY"] = 1] = "BEFORE_1_DAY";
    EmailNotificationTiming[EmailNotificationTiming["BEFORE_3_DAYS"] = 2] = "BEFORE_3_DAYS";
    EmailNotificationTiming[EmailNotificationTiming["BEFORE_1_WEEK"] = 3] = "BEFORE_1_WEEK";
})(EmailNotificationTiming = exports.EmailNotificationTiming || (exports.EmailNotificationTiming = {}));
var EmailNotificationId;
(function (EmailNotificationId) {
    EmailNotificationId[EmailNotificationId["EMAIL_RSVP_CONFIRMATION"] = 0] = "EMAIL_RSVP_CONFIRMATION";
    EmailNotificationId[EmailNotificationId["EMAIL_WAITING_NEW_SPOTS_AVAILABLE"] = 1] = "EMAIL_WAITING_NEW_SPOTS_AVAILABLE";
    EmailNotificationId[EmailNotificationId["EMAIL_EVENT_CANCELATION"] = 2] = "EMAIL_EVENT_CANCELATION";
    EmailNotificationId[EmailNotificationId["EMAIL_UPCOMING_EVENT_REMINDER"] = 3] = "EMAIL_UPCOMING_EVENT_REMINDER";
    EmailNotificationId[EmailNotificationId["EMAIL_ORDER_CONFIRMATION"] = 4] = "EMAIL_ORDER_CONFIRMATION";
})(EmailNotificationId = exports.EmailNotificationId || (exports.EmailNotificationId = {}));
var PushNotificationId;
(function (PushNotificationId) {
    PushNotificationId[PushNotificationId["PUSH_EVENT_UPDATED"] = 0] = "PUSH_EVENT_UPDATED";
    PushNotificationId[PushNotificationId["PUSH_EVENT_CANCELATION"] = 1] = "PUSH_EVENT_CANCELATION";
    PushNotificationId[PushNotificationId["PUSH_UPCOMING_EVENT_REMINDER"] = 2] = "PUSH_UPCOMING_EVENT_REMINDER";
    PushNotificationId[PushNotificationId["PUSH_EVENT_CREATED"] = 3] = "PUSH_EVENT_CREATED";
})(PushNotificationId = exports.PushNotificationId || (exports.PushNotificationId = {}));
var GuestRegistrationReportType;
(function (GuestRegistrationReportType) {
    GuestRegistrationReportType[GuestRegistrationReportType["INSTANT_UPDATE"] = 0] = "INSTANT_UPDATE";
    GuestRegistrationReportType[GuestRegistrationReportType["DAILY_SUMMARY"] = 1] = "DAILY_SUMMARY";
})(GuestRegistrationReportType = exports.GuestRegistrationReportType || (exports.GuestRegistrationReportType = {}));
var RsvpStatus;
(function (RsvpStatus) {
    RsvpStatus[RsvpStatus["YES"] = 0] = "YES";
    RsvpStatus[RsvpStatus["NO"] = 1] = "NO";
    RsvpStatus[RsvpStatus["WAITING"] = 2] = "WAITING";
})(RsvpStatus = exports.RsvpStatus || (exports.RsvpStatus = {}));
var RsvpFieldset;
(function (RsvpFieldset) {
    RsvpFieldset[RsvpFieldset["DETAILS"] = 0] = "DETAILS";
    RsvpFieldset[RsvpFieldset["FORM"] = 1] = "FORM";
})(RsvpFieldset = exports.RsvpFieldset || (exports.RsvpFieldset = {}));
var OrderStatus;
(function (OrderStatus) {
    OrderStatus[OrderStatus["NA_ORDER_STATUS"] = 0] = "NA_ORDER_STATUS";
    OrderStatus[OrderStatus["FREE"] = 1] = "FREE";
    OrderStatus[OrderStatus["PENDING"] = 2] = "PENDING";
    OrderStatus[OrderStatus["PAID"] = 3] = "PAID";
    OrderStatus[OrderStatus["OFFLINE_PENDING"] = 4] = "OFFLINE_PENDING";
    OrderStatus[OrderStatus["INITIATED"] = 5] = "INITIATED";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
var OrderFieldset;
(function (OrderFieldset) {
    OrderFieldset[OrderFieldset["TICKETS"] = 0] = "TICKETS";
    OrderFieldset[OrderFieldset["DETAILS"] = 1] = "DETAILS";
    OrderFieldset[OrderFieldset["FORM"] = 2] = "FORM";
    OrderFieldset[OrderFieldset["INVOICE"] = 3] = "INVOICE";
})(OrderFieldset = exports.OrderFieldset || (exports.OrderFieldset = {}));
var TicketDefinitionFieldset;
(function (TicketDefinitionFieldset) {
    TicketDefinitionFieldset[TicketDefinitionFieldset["POLICY"] = 0] = "POLICY";
    TicketDefinitionFieldset[TicketDefinitionFieldset["DASHBOARD"] = 1] = "DASHBOARD";
})(TicketDefinitionFieldset = exports.TicketDefinitionFieldset || (exports.TicketDefinitionFieldset = {}));
var State;
(function (State) {
    State[State["VISIBLE"] = 0] = "VISIBLE";
    State[State["HIDDEN"] = 1] = "HIDDEN";
    State[State["FREE"] = 2] = "FREE";
    State[State["PAID"] = 3] = "PAID";
})(State = exports.State || (exports.State = {}));
var Format;
(function (Format) {
    Format[Format["EMAIL"] = 0] = "EMAIL";
    Format[Format["HOSTNAME"] = 1] = "HOSTNAME";
    Format[Format["IPV4"] = 2] = "IPV4";
    Format[Format["IPV6"] = 3] = "IPV6";
    Format[Format["URI"] = 4] = "URI";
    Format[Format["PHONE"] = 7] = "PHONE";
    Format[Format["CREDIT_CARD"] = 8] = "CREDIT_CARD";
    Format[Format["GUID"] = 9] = "GUID";
    Format[Format["COUNTRY"] = 10] = "COUNTRY";
    Format[Format["LANGUAGE"] = 11] = "LANGUAGE";
    Format[Format["DECIMAL_VALUE"] = 12] = "DECIMAL_VALUE";
    Format[Format["CURRENCY"] = 13] = "CURRENCY";
})(Format = exports.Format || (exports.Format = {}));
var Exposure;
(function (Exposure) {
    Exposure[Exposure["PRIVATE"] = 0] = "PRIVATE";
    Exposure[Exposure["INTERNAL"] = 1] = "INTERNAL";
    Exposure[Exposure["PUBLIC"] = 2] = "PUBLIC";
})(Exposure = exports.Exposure || (exports.Exposure = {}));
var Maturity;
(function (Maturity) {
    Maturity[Maturity["ALPHA"] = 0] = "ALPHA";
    Maturity[Maturity["BETA"] = 1] = "BETA";
    Maturity[Maturity["IA"] = 2] = "IA";
    Maturity[Maturity["GA"] = 3] = "GA";
})(Maturity = exports.Maturity || (exports.Maturity = {}));
